import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FadeInOnScrollDirective } from '../../../directives/fade-in-on-scroll.directive';
import { eventInfo } from '../../../app.constants';

@Component({
  selector: 'app-location',
  imports: [FadeInOnScrollDirective],
  templateUrl: './location.component.html',
  styleUrl: './location.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocationComponent {
  protected readonly eventInfo = eventInfo();
}
